import React, { useState } from 'react';
import { Alert, Box, Button, Flex, Image, Input, Link, Text } from '@chakra-ui/react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { authReturn, authDestination, rememberAuthReturn } from './client/authContinuation';
import ProviderButtons from './auth/ProviderButtons';
import { clearSignupProof, signupDestination } from './auth/signupEmailFlow';
import './App.css';

export default function Register() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const register = async event => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const target = rememberAuthReturn(authReturn());
      const response = await fetch('/api/register', { method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email, return_to: target }) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Could not start signup. Please try again.');
      sessionStorage.setItem('pabs-signup-email', email.trim());
      clearSignupProof(email);
      navigate(signupDestination('/thank-you', email, target));
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return <Flex className="start-container" direction={{ base: 'column', md: 'row' }}>
    <Box flex="1.5" minW={0} pr={{ base: 0, md: '5%' }}>
      <Link as={RouterLink} to="/"><Image src="/images/pablo_logo1.0.svg" alt="Pabs home" boxSize="48px" mb="5%" /></Link>
      <Text as="h1" fontSize={{ base: '4xl', md: '6xl' }} fontWeight="bold" letterSpacing="tight" mb={4} lineHeight={1.1} color="brand.900">Get started</Text>
      <Text fontSize={{ base: 'lg', md: '2xl' }} color="brand.600">Continue with Google or use your email to create a Pabs account.</Text>
    </Box>
    <Box className="container-box" minW={0} flex={{ base: 'none', md: '1' }} mt={{ base: 6, md: '5%' }}>
      <ProviderButtons inset />
      <form onSubmit={register} className="fed-form">
        {error && <Alert status="error" role="alert" mb={4}>{error}</Alert>}
        <Input aria-label="Email" name="email" placeholder="Enter your email" _placeholder={{ color: 'gray.600' }} type="email" autoComplete="email" value={email}
          onChange={event => setEmail(event.target.value)} mb={4} required className="fed-input" />
        <Button colorScheme="brand" type="submit" width="100%" isLoading={busy} loadingText="Sending your code…">Continue with email</Button>
        <Text mt={4} fontSize="sm" color="gray.700">Read our <Link href="/terms" target="_blank" rel="noopener noreferrer" textDecoration="underline">Terms and Conditions</Link> and <Link href="/privacy" target="_blank" rel="noopener noreferrer" textDecoration="underline">Privacy Policy</Link>.</Text>
        <Text mt={6} fontSize="sm">Already have an account? <Link as={RouterLink} to={authDestination('/login')} textDecoration="underline">Sign in</Link></Text>
      </form>
    </Box>
  </Flex>;
}
